import { createContext } from 'react';
import type { DevtoolsContextType } from '@/contexts/Devtools/DevtoolsStateType';

export default createContext<DevtoolsContextType | null>(null);
